module.exports = __webpack_public_path__ + "img/logo.dc6bb77b.png";